module.exports = __webpack_public_path__ + "static/avatar-example-330bd417d826f8b7c05c5620eca3a055.png";